import api from './api'

export const getColumns = async () =>{
    return await api.get("/cms/column/get")
}

export const getBanner = async params =>{
    return await api.get("/cms/bannerConfig/get",params)
}